// Show/hide logic for the "Enable browser notifications" banner that
// nudges Pro web users to grant Notification permission. Extracted as a
// pure function so the gating matrix is testable without mounting the
// React tree or stubbing browser globals.
//
// The actual React component (EnableBrowserPushBanner in
// AgentsScreen.tsx) is the live caller: it reads bridge.isNative,
// Notification.permission, and the dismissal flag, and passes them in.

export const PUSH_BANNER_DISMISSED_KEY = 'hearth.dismissed.browserPushBanner'

export type BannerInputs = {
  isNative: boolean
  // `undefined` covers "no Notification API in this environment" —
  // pre-16 Safari, some webviews, the SSR fallback. Indistinguishable
  // from "can't show a notification" for our purposes.
  notificationPermission: NotificationPermission | undefined
  dismissed: boolean
}

export function shouldHideBrowserPushBanner(inputs: BannerInputs): boolean {
  if (inputs.isNative) return true
  if (inputs.notificationPermission === undefined) return true
  // 'granted' = already enabled, nothing to nudge.
  // 'denied' = browser blocks re-prompts, banner is useless.
  // Only 'default' should ever surface the banner.
  if (inputs.notificationPermission !== 'default') return true
  if (inputs.dismissed) return true
  return false
}
